import React from 'react';

export default () => {
  return (
    <>
      <div className="container container-full privacy-top">
        <div className="container ">
          <div className="row extra">
            This Privacy Policy is a document related to the Terms of Service of
            the Ulam Labs Website (“Terms of Service”). Definitions of the terms
            used in this Privacy Policy were included in the Terms of Service.
            The provisions of the Terms of Service are applied accordingly.
          </div>
          <div className="row extra">
            The Policy is for information purposes and serves satisfaction of
            information obligations imposed on the data controller under GDPR,
            i.e. Regulation (EU) 2016/679 of 27 April 2016 on the protection of
            natural persons with regard to the processing of personal data and
            on the free movement of such data, and repealing Directive 95/46/EC
            (General Data Protection Regulation).
          </div>
        </div>
      </div>
      <div className="rodo-list privacy-bottom">
        <div className="container">
          <ol>
            <li>
              PERSONAL DATA CONTROLLER
              <ol>
                <li>
                  The Controller of the personal data provided by the User is
                  Konrad Rotkiewicz conducting a business activity under name
                  Ulam Labs Konrad Rotkiewicz at ul. Powstańców Śląskich, nr
                  121, lok. 5 (53-332 Wrocław), Tax Identification Number NIP:
                  5010046816, National Business Registry number REGON:
                  021880186.
                </li>
                <li>
                  You may contact Ulam Labs as the Personal Data Controller in
                  particular via e-mail at:{' '}
                  <a href="mailto:privacy@ulam.io">privacy@ulam.io</a>.
                </li>
              </ol>
            </li>
            <li>
              DATA PROCESSING METHOD{' '}
              <ol>
                <li>
                  The purpose and scope of the processing of Users’ personal
                  data are determined by the scope of consents and data provided
                  by the User sent by means of a relevant form.
                </li>
                <li>
                  The processing of Users’ personal data may pertain to e-mail
                  address, IP address, first and last name, phone number, image.
                </li>
                <li>
                  Personal data of the Users will be processed for the following
                  purposes:
                  <ol>
                    <li>
                      compliance with obligations resulting from legal
                      provisions—the legal basis is the statutory authorisation
                      to process data necessary to act in line with the law
                      (Article 6.1(c) of the GDPR);
                    </li>
                    <li>
                      provision of services by electronic means through the
                      Website—the legal basis is the statutory authorization to
                      process data which is necessary to perform an agreement if
                      the data subject is a party to such agreement, or if it is
                      essential for undertaking certain actions prior to
                      conclusion of an agreement upon request of the data
                      subject (Article 6.1(b) of the GDPR);
                    </li>
                    <li>
                      initiation of promotional and commercial actions carried
                      out by Ulam Labs—the legal basis is a legitimate interest
                      executed by Ulam Labs (Article 6.1.(f) of the GDPR) or
                      voluntary consent (Article 6.1(a) of the GDPR);
                    </li>
                  </ol>
                </li>
                <li>
                  Users’ personal data will be processed for the following
                  period:
                  <ol>
                    <li>
                      a period sufficient for Ulam Labs to prove the appropriate
                      performance of its obligations, whereby such term
                      corresponds to the period of limitation of claims;
                    </li>
                    <li>
                      in the case of marketing actions, until the concerned
                      person objects to further processing of his/her personal
                      data for marketing purposes or until he/she revokes the
                      consent to be sent messages with marketing content.
                    </li>
                  </ol>
                </li>
                <li>
                  Upon the lapse of the above mentioned period, personal data
                  will be deleted, unless their processing is necessary under
                  another legal basis.
                </li>
                <li>
                  In certain situations Ulam Labs may transfer Users’ personal
                  data to third countries (i.e. beyond the European Economic
                  Area), in particular to the United States of America under the
                  EU-U.S. Privacy Shield. In such a case, Ulam Labs will take
                  every effort to ensure that Users’ personal data are
                  appropriately secured and will transfer Users’ personal data
                  only to entities which guarantee the appropriate level of
                  protection of data.
                </li>
              </ol>
            </li>
            <li>
              PROFILING
              <ol>
                <li>
                  If the User has consented to profiling, Ulam Labs will be
                  entitled to profiling.
                </li>
                <li>
                  Profiling is a form of automated processing of personal data
                  that will allow Ulam Labs to assess the User’s personal
                  factors, primarily related to User’s preferences, interests
                  and needs that result from the User’s behavior on the Website
                  in order to adapt the Services to the User’s need, and provide
                  the User with content that may of interest, as well as the
                  display of ads that respect his preferences.
                </li>
                <li>
                  At any time, the User may object to profiling by writing to
                  the e-mail address:{' '}
                  <a href="mailto:privacy@ulam.io">privacy@ulam.io</a>.
                </li>
              </ol>
            </li>
            <li>
              RECIPIENTS OF DATA
              <ol>
                <li>
                  Ulam Labs may entrust the processing of Users’ personal data
                  to third parties to ensure the functioning of the Website,
                  provision of Services, as well as the exercising of its rights
                  or compliance with its obligations connected with processing.
                  In such a case, data recipients may include: the hosting
                  provider, the provider of the CRM service, the e-mail
                  operator, legal firm.
                </li>
                <li>
                  Personal data collected by Ulam Labs may also be disclosed to:
                  competent state bodies upon their request on the basis of
                  relevant provisions of law, or other persons and entities—in
                  the cases prescribed in the provisions of law.
                </li>
                <li>
                  Each entity to which Ulam Labs transfers personal data for
                  processing on the basis of a personal data transfer agreement
                  (hereinafter referred to as “Transfer Agreement”) guarantees
                  an adequate level of security and confidentiality of the
                  processing of personal data. The entity processing User’s
                  personal data on the basis of the Transfer Agreement may
                  process them through another entity only upon prior consent of
                  Ulam Labs.
                </li>
                <li>
                  Disclosing personal data to unauthorized entities under this
                  Privacy Policy may only take place upon prior consent of the
                  data subject.
                </li>
                <li>
                  If personal data are transferred to entities from third
                  countries for processing, such transfer may take place on the
                  basis of respective model contract clauses or decisions of the
                  European Commission, in particular the EU-U.S. Privacy Shield,
                  i.e. Commission Implementing Decision 2016/1250/EU of 12 July
                  2016.
                </li>
              </ol>
            </li>
            <li>
              RIGHTS OF DATA SUBJECT
              <ol>
                <li>
                  In connection with the processing of data the User has the
                  right to: (a) delete the collected personal data referring to
                  him/her both from the system belonging to Ulam Labs as well as
                  from bases of entities which have co-operated with Ulam Labs,
                  (b) restrict the processing of data, (c) portability of the
                  personal data collected by Ulam Labs and referring to the
                  User, in this to receive them in a structured form, (d)
                  request Ulam Labs to enable him/her access to his/her personal
                  data and to rectify them, (e) object to processing, (f)
                  withdraw the consent towards Ulam Labs at any time without
                  affecting the legality of the processing carried out on the
                  basis of the consent before it is withdrawn, (g) lodge a
                  complaint about Ulam Labs to the supervisory authority
                  (President of the Personal Data Protection Office).
                </li>
              </ol>
            </li>
            <li>
              OTHER DATA
              <ol>
                <li>
                  Ulam Labs may store http enquiries, therefore the files
                  containing web server logs may store certain data, including
                  the IP address of the computer sending the enquiry, station
                  name—identification through http protocol, if possible, date
                  and system time of registration on website of Ulam Labs and
                  receipt of the enquiry, number of bytes sent by the server,
                  the URL address of the site visited by the User before if the
                  User has entered the website through a link, information
                  concerning User’s browser, information on errors, information
                  on User’s device, identifiers of mobile devices (i.e. Apple
                  Advertising Identifier). Web server logs may be collected for
                  the purpose of proper administration of the website. Only
                  persons authorized to administer the IT system have access to
                  data. Files containing web server logs may be analyzed for the
                  purpose of preparing statistics concerning traffic on the
                  website and occurring errors. Summary of such details does not
                  enable identification of any person.
                </li>
              </ol>
            </li>
            <li>
              SECURITY
              <ol>
                <li>
                  Ulam Labs applies technological and organisational means in
                  order to secure the processing of personal data adequately to
                  the threats and category of data to be secured, in particular,
                  through technical and organisational means Ulam Labs secures
                  data against being disclosed to unauthorised persons, taken
                  over by an unauthorised person, processed in violation of the
                  law, and changed, lost, damaged or destroyed. The collected
                  Users’ personal data are stored on a secured server, moreover,
                  the data are secured by Ulam Labs’ internal procedures related
                  to the processing of personal data and information security
                  policy.
                </li>
                <li>
                  Ulam Labs has also implemented appropriate technical and
                  organisational means, such as pseudonymisation, designed to
                  effectively enforce the data protection principles, such as
                  data minimisation, and for the purpose of providing the
                  processing with necessary safeguards, so as to meet the GDPR
                  requirements and protect the rights of data subjects.
                </li>
                <li>
                  At the same time, Ulam Labs states that using the Internet and
                  services provided by electronic means may pose a threat of
                  malware breaking into User’s teleinformatic system and device,
                  as well as any other unauthorised access to User’s data,
                  including personal details, by third parties. In order to
                  minimize such threats, the User should use appropriate
                  technical security means, e.g. use updated antivirus programs
                  or programs securing the identification in the Internet. In
                  order to obtain detailed and professional information related
                  to security in the Internet, Ulam Labs recommends taking
                  advice from entities specializing in such IT services.
                </li>
              </ol>
            </li>
            <li>
              COOKIES AND USER IDENTIFIERS{' '}
              <ol>
                <li>
                  For the purposes of correct operation of the website, Ulam
                  Labs uses a cookie support technology. Cookies are packages of
                  information stored on User’s device through the website,
                  usually containing information corresponding to the intended
                  use of a particular file, by means of which the User uses the
                  website www.ulam.io (Website)—these are usually: address of
                  the Internet website, date of publishing, lifetime of a
                  cookie, unique number, and additional information
                  corresponding to the intended use of a particular file.
                </li>
                <li>
                  The website uses two types of cookies: (a) session cookies,
                  which are permanently deleted upon closing the session of the
                  browser; (b) permanent cookies, which remain on the device
                  after closing the session until they are deleted.
                </li>
                <li>
                  It is not possible to identify the User on the basis of cookie
                  files, whether session or permanent. The cookie mechanism
                  prevents collection of any personal data.
                </li>
                <li>
                  The cookies used on the website are safe for User’s device, in
                  particular they prevent viruses or other software from
                  breaking into to the device.
                </li>
                <li>
                  Files generated directly by Ulam Labs may not be read by other
                  websites. Third-party cookies (i.e. cookies provided by
                  entities co-operating with Ulam Labs) may be read by an
                  external server.
                </li>
                <li>
                  The User may individually change the cookie settings at any
                  time, stating the conditions of their storage, through the
                  Internet browser settings or configuration of the service.
                </li>
                <li>
                  First of all, the User may disable storing cookies on his/her
                  device in accordance with the instructions of the browser
                  producer, but this may disable certain parts of or the entire
                  operation of the website.
                </li>
                <li>
                  The User may also individually remove cookies stored on
                  his/her device at any time in accordance with the instructions
                  of the browser producer.
                </li>
                <li>
                  Ulam Labs uses own cookies for the following purposes:
                  configuration of the Website and adjustment of the page
                  content to the preferences or conduct of users; analysis and
                  research of views, click number and path taken on the website
                  to improve the appearance and organisation of content on the
                  website, time spent on the website, number and frequency of
                  visits on the website.
                </li>
                <li>
                  Ulam Labs uses third-party cookies for the following purposes:
                </li>
                <div className="table-privacy">
                  <table>
                    <thead className="table-privacy head">
                      <tr>
                        <th scope="col">Tool:</th>
                        <th scope="col">Purpose of storing:</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td data-label="Tool">Google Analytics</td>
                        <td data-label="Purpose of storing:">
                          <span>
                            collecting general or anonymous statistical data by
                            means of analytical tools
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td scope="row" data-label="Tool">
                          Google Adwords
                        </td>
                        <td data-label="Purpose of storing:">
                          promotional and marketing actions within the
                          retargeting process
                        </td>
                      </tr>
                      <tr>
                        <td scope="row" data-label="Tool">
                          Apple Search Ads
                        </td>
                        <td data-label="Purpose of storing:">
                          promotional and marketing actions within the
                          retargeting process in Apple AppStore
                        </td>
                      </tr>
                      <tr>
                        <td scope="row" data-label="Acount">
                          Facebook Ads
                        </td>
                        <td data-label="Purpose of storing:">
                          promotional and marketing actions within the
                          retargeting process
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <li>
                  Details concerning cookie support are available in the
                  settings of the browser used by the User.
                </li>
              </ol>
            </li>
            <li>
              FINAL PROVISIONS
              <ol>
                <li>This Privacy Policy comes into effect on 17.02.2020.</li>
              </ol>
            </li>
          </ol>
        </div>
      </div>
    </>
  );
};
